import Button from 'components/shared/Button/Button';

const InnacurateData = ({
  title = 'Notice something inaccurate?',
  description = "If we've overlooked any details about your organization, let us know",
  buttonText
} = {}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2 p-4 text-center">
      <div className="text-xl text-primary-500">{title}</div>
      {typeof description === 'string' && description !== '' ? (
        <p className="mb-2 text-sm text-neutral-500">{description}</p>
      ) : (
        description
      )}
      <Button variant="secondary" text={buttonText ?? 'Reach our support staff'} />
    </div>
  );
};
export default InnacurateData;
